/**
 * Les loadouts renvoyés par l'API ont leurs clés camelisées : `WEAPON_PISTOL` devient
 * `wEAPONPISTOL`, `WEAPON_CARBINERIFLE_MK2` devient `wEAPONCARBINERIFLEMK2`.
 * On ne peut donc pas reconstruire le nom d'origine (on ne sait pas où replacer les `_`),
 * mais on peut comparer les deux noms en ignorant les `_` et la casse.
 */
const normalizeWeaponName = name => String(name || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

/**
 * Retrouve la définition d'une arme dans les variables publiques, que le nom fourni soit
 * canonique (`WEAPON_CARBINERIFLE_MK2`) ou camelisé (`wEAPONCARBINERIFLEMK2`).
 */
export const findWeaponDetails = (weapons, name) => {
  if (!name) {
    return null
  }
  const normalized = normalizeWeaponName(name)
  return (weapons || []).find(weapon => normalizeWeaponName(weapon.name) === normalized) || null
}

export default findWeaponDetails
